// Central product mapping. Gumroad URLs are PLACEHOLDERS — replace with your real
// product URLs (see docs/add-a-product.md). Nothing here triggers payment code;
// checkout & delivery are handled entirely by Gumroad.

export const GUMROAD_BASE = "https://myfinancesguru.gumroad.com/l"; // placeholder handle

// Real spreadsheet files live on the backend and are served at
// `${REACT_APP_BACKEND_URL}/api/downloads/<file>`. Use downloadUrl(product) to build the link.
export const downloadUrl = (product) =>
  product.file ? `${process.env.REACT_APP_BACKEND_URL}/api/downloads/${product.file}` : null;

export const PRODUCTS = [
  {
    id: "personal-finance-dashboard",
    name: "Personal Finance Dashboard",
    price: 19,
    tagline: "Track everything in one Google Sheet",
    description:
      "A complete Google Sheets dashboard to track income, spending, savings, and net worth month over month — built for Canadians.",
    features: ["Automatic monthly summaries", "Net worth tracker", "Spending categories", "Visual charts", "Works in Google Sheets"],
    gumroadUrl: `${GUMROAD_BASE}/personal-finance-dashboard`,
    file: "personal-finance-dashboard.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/c34b838d8994bbe3592c0edb7a18a1475b2cd87c4f5d2f7b7139ce479d94221b.jpeg",
    badge: "Bestseller",
    category: "All-in-one",
  },
  {
    id: "retirement-planner",
    name: "Retirement Planner",
    price: 29,
    tagline: "Map your path to retirement",
    description:
      "Project your retirement income from RRSP, TFSA, CPP and OAS and see exactly how much you need to save each month.",
    features: ["CPP/OAS projections", "RRSP & TFSA modelling", "Withdrawal planning", "Inflation adjusted", "Scenario comparison"],
    gumroadUrl: `${GUMROAD_BASE}/retirement-planner`,
    file: "retirement-planner.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/d10bc2a6c99f915dc102125b294fbec0709db4dfaca4dec873f1c32cb678aea9.jpeg",
    category: "Retirement",
  },
  {
    id: "net-worth-tracker",
    name: "Net Worth Tracker",
    price: 12,
    tagline: "Watch your wealth grow",
    description: "A focused Google Sheet to log assets and debts and visualize your net worth trend over time.",
    features: ["Asset & liability logging", "Monthly net worth chart", "Goal tracking", "Simple and clean"],
    gumroadUrl: `${GUMROAD_BASE}/net-worth-tracker`,
    file: "net-worth-tracker.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/b1dcbcf834cf3f219f0c06e7c6956da97d315edb2a3efad2e0b9807ac2faf8ab.jpeg",
    category: "Tracking",
  },
  {
    id: "debt-freedom-planner",
    name: "Debt Freedom Planner",
    price: 19,
    tagline: "Crush debt faster",
    description: "Compare avalanche and snowball payoff strategies and build a month-by-month plan to become debt-free.",
    features: ["Avalanche vs snowball", "Payoff timeline", "Interest saved calculator", "Progress tracker"],
    gumroadUrl: `${GUMROAD_BASE}/debt-freedom-planner`,
    file: "debt-freedom-planner.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/96a2cc1de65c5149f8f5ffc41e3d4467f3be478b0f2d0035844fa03015a9951c.jpeg",
    category: "Debt",
  },
  {
    id: "mortgage-planner",
    name: "Mortgage Planner",
    price: 19,
    tagline: "Own your home sooner",
    description: "Model your Canadian mortgage, test prepayments and accelerated payments, and see interest saved.",
    features: ["Amortization schedule", "Prepayment modelling", "Accelerated payment options", "Renewal planning"],
    gumroadUrl: `${GUMROAD_BASE}/mortgage-planner`,
    file: "mortgage-planner.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/c3cf8aa79df8ca1c4117ce93067642ba2b1221ac8021d8263742f12d1c42e7e7.jpeg",
    category: "Home",
  },
  {
    id: "tfsa-rrsp-planner",
    name: "TFSA & RRSP Planner",
    price: 19,
    tagline: "Optimize your registered accounts",
    description: "Plan TFSA and RRSP contributions, track your room, and project tax-advantaged growth.",
    features: ["Contribution room tracker", "Growth projections", "Tax savings estimator", "TFSA vs RRSP guidance"],
    gumroadUrl: `${GUMROAD_BASE}/tfsa-rrsp-planner`,
    file: "tfsa-rrsp-planner.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/37a226a62d942b6cdc0c585a728bbb3d71d0ca4f213d1094828c416d5a77d940.jpeg",
    badge: "Popular",
    category: "Investing",
  },
  {
    id: "family-financial-planner",
    name: "Family Financial Planner",
    price: 29,
    tagline: "Plan for the whole household",
    description: "A comprehensive planner for families: budgeting, savings goals, RESP planning and shared net worth.",
    features: ["Household budget", "RESP planning", "Shared goals", "Kids' savings tracker"],
    gumroadUrl: `${GUMROAD_BASE}/family-financial-planner`,
    file: "family-financial-planner.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/f4873bacba419b928e564f40050f7234e948a518c8fda82fdac4345b7e17b60d.jpeg",
    category: "Family",
  },
  {
    id: "fire-planner",
    name: "FIRE Planner",
    price: 29,
    tagline: "Financial Independence, Retire Early",
    description: "Model your FIRE number, savings rate, and years-to-freedom with Canadian tax considerations.",
    features: ["FIRE number calculator", "Savings rate tracker", "Coast/Lean/Fat FIRE", "Withdrawal simulator"],
    gumroadUrl: `${GUMROAD_BASE}/fire-planner`,
    file: "fire-planner.xlsx",
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/20c7658d758edd306535854ec7abdb502b8ef7eae04bfafc8055b05579c7cf92.jpeg",
    category: "Investing",
  },
  {
    id: "ultimate-toolkit",
    name: "Ultimate Toolkit Bundle",
    price: 79,
    tagline: "Every planner, one price",
    description: "Get all MyFinancesGuru planners in one bundle and save. The complete Canadian personal finance toolkit.",
    features: ["All 8 planners included", "Free future updates", "Best value", "Lifetime access"],
    gumroadUrl: `${GUMROAD_BASE}/ultimate-toolkit`,
    image: "https://static.prod-images.emergentagent.com/jobs/d9cd166a-2c1e-4806-8308-daf575f099bd/images/c34b838d8994bbe3592c0edb7a18a1475b2cd87c4f5d2f7b7139ce479d94221b.jpeg",
    badge: "Best value",
    category: "Bundle",
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);
